module.exports = {
      id: "google-g-usage",
      viewBox: "0 0 46 46",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#google-g",
      toString: function () {
        return this.url;
      }
    }